export default __webpack_public_path__ + "89cdef8a42baa72d1202d4023daf224c.png";